import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { addBatchId } from "state/reducers/communicationBatching";

let PAGELIST = [];
let pageListIncluded = [];
const PAGE_ORDER = ["details", "email", "text", "push", "list", "review"];
const V2MarketingRoot='v2-marketing';

export const generatePageList = (batchId, communicationTypes)  => {

  if (pageListIncluded.length) {
    Object.keys(communicationTypes).forEach((type) => {
      if (
        (communicationTypes[type] && !pageListIncluded.includes(type)) ||
        (!communicationTypes[type] && pageListIncluded.includes(type))
      ) {
        PAGELIST = [];
      }
    });
  }

  if (PAGELIST.length) {
    return PAGELIST;
  }

  pageListIncluded = [];
  PAGE_ORDER.forEach((page) => {
    if (communicationTypes[page] || ["details", "list", "review"].includes(page)) {
      pageListIncluded.push(page);
      PAGELIST.push({ link: `/${V2MarketingRoot}/batch-${page}/${batchId}`, step: page });
    }
  });
  return PAGELIST;
};

export default ({
  fetchBatch = false,
  currentPage,
}) => {
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState();
  const dispatch = useDispatch();
  const params = useParams();
  const {
    communicationTypes,
    batchId,
  } = useSelector((state) => state.communicationBatching);

  if (!currentPage) {
    throw new Error('uhOh');
  }

  generatePageList(batchId, communicationTypes);

  const getNextLink = () => {
    const idx = PAGELIST.findIndex((page) => page.step === currentPage);

    if (idx + 1 >= PAGELIST.length) { return null; }
    return PAGELIST[idx + 1].link;
  };

  const getPreviousLink = () => {
    const idx = PAGELIST.findIndex((page) => page.step === currentPage);
    if (idx - 1 < 0) { return null; }
    return PAGELIST[idx - 1].link;
  };

  const getBatchData = async () => {
    setFetching(true);
    // gets data from backend and replaces redux state
    dispatch(addBatchId(params.type));
    setFetching(false);
    setLoading(false);
  };

  useEffect(() => {
    if (fetchBatch) {
      if (params.batchId === batchId) {
        setLoading(false);
      } else {
        getBatchData();
      }
    }
  }, []);

  return {
    getNextLink,
    getPreviousLink,
    loading,
    fetching,
  };
};
